<template lang="pug">
    div.has-fixed-footer
        .alert.alert-warning(v-if="missingBiobankAssignment")
            | No biobank is assigned to this account.
        .alert.alert-warning(v-if="err") {{err.message}}
        BiobankEditCard.mb-sm-3(
            v-if="biobank",
            v-model="biobank"
        )
</template>

<script>
import BiobankEditCard from "./BiobankEditCard.vue";
import {getBiobank, getPerson} from "../api";

export default {
    components: {BiobankEditCard},
    data() {
        return {
            biobank: null,
            err: null,
            missingBiobankAssignment: false
        }
    },
    created() {
        const biobankId = localStorage.getItem("biobank");
        if (!biobankId || biobankId === "null" || biobankId === "undefined") {
            this.missingBiobankAssignment = true;
            return;
        }
        getBiobank(biobankId)
        .then((biobank) => {
          this.biobank = biobank;
        })
        .catch(err => this.err = err);
    }
}
</script>
